var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "coupon-card",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 0 16 C 0 7.163 7.163 0 16 0 L 112 0 C 120.837 0 128 7.163 128 16 L 128 31.188 C 123.694 31.188 120.203 34.678 120.203 38.985 C 120.203 43.291 123.694 46.782 128 46.782 L 128 112 C 128 120.837 120.837 128 112 128 L 16 128 C 7.163 128 0 120.837 0 112 L 0 46.755 C 0.215 46.773 0.431 46.782 0.65 46.782 C 4.956 46.782 8.447 43.291 8.447 38.985 C 8.447 34.678 4.956 31.188 0.65 31.188 C 0.431 31.188 0.215 31.197 0 31.214 L 0 16 Z",
    fill: "#E63537"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.65ed34e04bedc5923b3b12742f4cd372.svg";
export { ForwardRef as ReactComponent };